<mat-sidenav-container class="sidenav-container">
  <!-- Top Bar -->
  <mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="toggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
    <span class="app-title">ระบบไร่ออนไลน์</span>
    <span class="spacer"></span>
    <button mat-icon-button aria-label="Notifications">
      <mat-icon>notifications</mat-icon>
    </button>
    <button mat-icon-button aria-label="User Account">
      <mat-icon>account_circle</mat-icon>
    </button>
  </mat-toolbar>

  <!-- Sidebar -->
  <mat-sidenav mode="side" [(opened)]="isSidebarOpen" class="sidenav">
    <mat-nav-list>
      <mat-list-item>Dashboard</mat-list-item>
      <mat-list-item>Profile</mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content>
    <!-- Content will be here -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
